import FirebaseContext, { withFirebase } from './context'
import Firebase, { Timestamp } from './firebase'

export default Firebase

export { FirebaseContext, withFirebase, Timestamp }
